import type { RouteRecordRaw } from 'vue-router'
import { RouteList } from '@/routes/RouteList'
import { MenuCode } from '@/shared'
import { FeatureEnum } from '@/enums/FeatureEnum'
import { AbilityEnum } from '@/enums/AbilityEnum'

const NavBar = () => import('@/components/Layout/AuthenticatedNavBar.vue')
const SubSideBar = () => import('@/components/Layout/SubSideBar.vue')
const DashboardMain = () => import('@/components/Dashboard/DashboardMain.vue')
const SubjectBusinessListView = () => import('@/views/Enterprise/SubjectBusinessListView.vue')

export default <RouteRecordRaw[]>[
  {
    path: RouteList.ENTERPRISE.INDEX.PATH,
    name: RouteList.ENTERPRISE.INDEX.NAME,
    components: {
      default: DashboardMain,
      SideBar: SubSideBar,
      NavBar,
    },
    props: {
      SideBar: {
        menuCode: MenuCode.Enterprise,
        title: 'Enterprise',
      },
    },
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      feature: [FeatureEnum.ENTERPRISE],
      permission: [AbilityEnum.ENTERPRISE],
      title: 'Enterprise - Subject Businesses',
    },
    redirect: {
      name: RouteList.ENTERPRISE.SUBJECTS.INDEX.NAME,
    },
    children: [
      {
        path: RouteList.ENTERPRISE.SUBJECTS.INDEX.PATH,
        name: RouteList.ENTERPRISE.SUBJECTS.INDEX.NAME,
        component: SubjectBusinessListView,
        meta: {
          feature: [FeatureEnum.ENTERPRISE_SUBJECT_BUSINESSES],
          permission: [AbilityEnum.ENTERPRISE_SUBJECT_BUSINESSES, AbilityEnum.ENTERPRISE],
        },
      },
    ],
  },
]
